import React, { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button } from 'antd'
import MyInput from '../../../components/forms/input'
import MyImageUpload from '../../../components/forms/imageUpload'
import MyRadio from '../../../components/forms/radio'
import MyTextArea from '../../../components/forms/textArea'
import MySwitch from '../../../components/forms/switch'

const AddWebsiteBanner = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.thumbnail) {
      setErrorMsg({thumbnailEmpty: '图片不能为空'})
      return false
    }

    let path
    if (formValue.mode === 4) {
      path = formValue.finderUserName
    } else if (formValue.mode === 5) {
      path = formValue.finderUserName + '&' + formValue.feedId
    } else {
      path = formValue.path
    }

    axios.post('/p/deco/banner/add', {
      merchant_oid: merchantOid,
      source: 2,
      title: formValue.title,
      thumbnail: formValue.thumbnail,
      mode: formValue.mode,
      is_hide: formValue.is_hide,
      path: path,
      sort: Number(formValue.sort)
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('新横幅广告创建成功！')
          props.getBannerList()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <>
      <Modal
        destroyOnClose={true}
        title="创建横幅广告"
        width='760px'
        open={props.isOpen}
        onCancel={handleCancel}
        maskClosable={false}
        footer={[
          <Button key='cancel' onClick={handleCancel}>取消</Button>,
          <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
          <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
        ]}>

        <MyImageUpload 
          id="thumbnail"
          required
          label='图片'
          value={formValue.thumbnail}
          setValue={setFormValue}
          errorMsg={errorMsg.thumbnailEmpty}
        />

        <MyInput
          id="title"
          autoFocus
          maxLength={64}
          label='标题'
          placeholder='请输入横幅广告的标题'
          value={formValue.title}
          onChange={setFormValue}
        />


        <MyRadio
          id='mode'
          label='跳转页面'
          options={[
            {
              label: '内部路径',
              value: 1,
            },
            {
              label: '外部网页',
              value: 2,
            },
            {
              label: '不跳转',
              value: 0,
            }
          ]}
          defaultValue={0}
          value={formValue.mode}
          onChange={setFormValue}
        />

        {[1, 2].includes(formValue.mode) && <MyTextArea 
          id="path"
          minRows={2}
          placeholder='请输入地址'
          value={formValue.path}
          onChange={setFormValue}
        />}

        {formValue.mode === 5 && <MyInput
          id="feedId"
          maxLength={128}
          label='视频id'
          placeholder='请输入视频 feedId'
          value={formValue.feedId}
          onChange={setFormValue}
        />}

        <MySwitch 
          id='is_hide'
          label='是否隐藏'
          onChange={setFormValue}
        />

        <MyInput
          type='number'
          id="sort"
          label='排序'
          value={formValue.sort}
          onChange={setFormValue}
          styles={{ width: '60px' }}
          min={0}
          max={1000}
        />
      </Modal>
    </>
  )
}

export default AddWebsiteBanner
